import { Component } from '@angular/core';

import DataSource from 'devextreme/data/data_source';
import { ThirdPartyAppsService } from './third-party-apps.service';

@Component({
    selector: 'third-party-apps-list',
    templateUrl: './third-party-apps-list.template.html',
    standalone: false
})
export class ThirdPartyAppsListComponent {
    constructor(
        private service: ThirdPartyAppsService
    ){
        this.dataSource = this.service.getDataSource();
    }

    public dataSource : DataSource;

    public remoteOperations = {
        paging: true,
        filtering: true,
        sorting: true,
        grouping: true,
        summary: true,
        groupPaging: true
    };
}